export const Role = {
  WANDERFIT_ADMIN: "WANDERFIT_ADMIN",
  WANDERFIT_SUPPORT: "WANDERFIT_SUPPORT",
  WANDERFIT_FINANCE: "WANDERFIT_FINANCE",
  PROPERTY_OWNER: "PROPERTY_OWNER",
  PROPERTY_MANAGER: "PROPERTY_MANAGER",
  VENUE_OWNER: "VENUE_OWNER",
  VENUE_EMPLOYEE: "VENUE_EMPLOYEE",
  GUEST: "GUEST",
} as const;

export type Role = (typeof Role)[keyof typeof Role];

export const ADMIN_ROLES = [
  Role.WANDERFIT_ADMIN,
  Role.WANDERFIT_SUPPORT,
  Role.WANDERFIT_FINANCE,
] as const satisfies readonly Role[];

export function isAdminRole(role: Role | null | undefined): boolean {
  return role != null && (ADMIN_ROLES as readonly Role[]).includes(role);
}
